import React, { useState } from 'react'
import ModalConfirm from './ModalConfirm';

const Package = ({course,setModalIsOpen,handleColse,getTrainingDaysMain}) => {
  const courses = course?.openQulRegs_pack;

  const formatDate = (dateStr) =>
    new Date(dateStr).toLocaleDateString("he-IL", { year: "numeric", month: "2-digit", day: "2-digit" });
   const [modalConfirmIsOpen, setModalConfirmIsOpen] = useState(false);  
  return (
    <div className='fixed top-0 h-screen z-20 left-0 flex flex-col items-center overflow-y-auto   py-2 w-full  bg-[#FDFFFC]/50 ' style={{ direction: "rtl" }}>
    <div  className='bg-white w-[50%] rounded-lg text-right    divide-y-2 divide-slate-500 border-0 drop-shadow-2xl shadow-2xl border-emerald-50 '>
        <div className='w-full bg-[#0d406b] rounded-t-md flex  border-[#0d406b] border-2'>
            <button className='p-1 px-2 m-3 border bg-slate-500 hover:bg-slate-200' onClick={() => {setModalIsOpen(false)
            //   
            }} >x</button>
        </div>
      {/* HEADER של המארז */}
      <div className="flex flex-col md:flex-row">
        <img
          src={`https://archivebureau.s3.eu-west-3.amazonaws.com/${course?.linkImage_pack}`}
          alt="תמונת מארז"
          className="w-full md:w-1/3 h-64 object-cover"
        />
        <div className="p-4 flex-1 text-right space-y-2">
          <h2 className="text-2xl font-bold text-green-700">
            {course?.name_pack || "מארז קורסים"}
          </h2>
          <p className="text-gray-700 line-clamp-3">
            {courses[0]?.mySelfQualificationDto.description}
          </p>
          <p className="text-lg font-semibold">
            מחיר כולל: {course?.price_pack === 0 ? "חינם" : `${course?.price_pack} ₪`}
          </p>
          <button className="bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded-xl mt-2" onClick={() => {setModalConfirmIsOpen(true)}}>
            להרשמה למארז
          </button>
        </div>
      </div>

      {/* רשימת קורסים */}
      <div className="p-4 bg-gray-50 rounded-b-lg">
        <h3 className="text-xl font-bold mb-2 text-right" style={{direction:"rtl"}}>ימי כשירות הכלולים מארז:</h3>
        <div className="grid md:grid-cols-2 gap-4">
          {courses.map((course, index) => {
            const q = course.mySelfQualificationDto;
            const firstDate = q.activityDays[0]?.date;
            const lastDate = q.activityDays[q.activityDays.length - 1]?.date;

            return (
              <div
                key={index}
                className="border rounded-lg p-4 bg-white shadow-sm text-right"
              >
                <h4 className="font-semibold text-green-800 text-lg mb-1">
                  {q.name}
                </h4>
                <p><strong>מיקום:</strong> {q.place}</p>
                <p><strong>מרצה:</strong> {q.instructor?.frame_manager || "—"}</p>
                <p>
                  <strong>תאריכים:</strong>{" "}
                  {firstDate ? `${formatDate(firstDate)} - ${formatDate(lastDate)}` : "—"}
                </p>
                <p><strong>ימי כשירות:</strong> {course.daysWork}</p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
    {modalConfirmIsOpen&&<ModalConfirm idCorse={course?.id_pack} handleColse={handleColse} setModalIsOpen={setModalConfirmIsOpen} getTrainingDaysMain={getTrainingDaysMain} request_register={"package"} ></ModalConfirm>}
    </div>
)
}

export default Package